import { render, staticRenderFns } from "./EduTable.vue?vue&type=template&id=125a5adf&scoped=true"
import script from "./EduTable.vue?vue&type=script&lang=js"
export * from "./EduTable.vue?vue&type=script&lang=js"
import style0 from "./EduTable.vue?vue&type=style&index=0&id=125a5adf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a5adf",
  null
  
)

export default component.exports